import { apiGet, apiPost, apiPatch } from './api';

export const getEvents = async () => {
    const response = await apiGet('/api/v1/ticketing/events/');
    return response.json();
};

export const getEventDetail = async (eventId) => {
    const response = await apiGet(`/api/v1/ticketing/events/${eventId}/`);
    return response.json();
};

export const getConferences = async () => {
    const response = await apiGet('/api/v1/ticketing/conferences/');
    return response.json();
};

export const getConferenceDetail = async (conferenceId) => {
    const response = await apiGet(`/api/v1/ticketing/conferences/${conferenceId}/`);
    return response.json();
};

export const createOrder = async ({ eventInstanceId, conferenceId, quantity, referredBy }) => {
    const body = conferenceId ? { conference_id: conferenceId, quantity } : { event_instance_id: eventInstanceId, quantity };
    if (referredBy) body.referred_by = referredBy;
    const response = await apiPost('/api/v1/ticketing/create-order/', body);
    return response.json();
};

export const confirmPayment = async ({ orderRef, paymentIntentId }) => {
    const response = await apiPost('/api/v1/ticketing/confirm-payment/', {
        order_ref: orderRef,
        payment_intent_id: paymentIntentId,
    });
    return response.json();
};

export const getMyOrders = async () => {
    const response = await apiGet('/api/v1/ticketing/my-orders/');
    return response.json();
};

export const getOrderDetail = async (orderRef) => {
    const response = await apiGet(`/api/v1/ticketing/my-orders/${orderRef}/`);
    return response.json();
};

export const createPaymentIntent = async ({ price, email, couponCode, orderRef }) => {
    const body = { price, email };
    if (couponCode) body.couponCode = couponCode;
    // Binds the intent to the order server-side: the API prices it from the order (not `price`)
    // and confirm-payment will only accept this intent for this order.
    if (orderRef) body.order_ref = orderRef;
    const response = await apiPost('/api/v1/payments/create-payment-intent', body);
    return response.json();
};

export const getOrganiser = async () => {
    const response = await apiGet('/api/v1/ticketing/organiser/');
    return response.json();
};

export const cancelOrder = async (orderRef) => {
    const response = await apiPost('/api/v1/ticketing/cancel-order/', { order_ref: orderRef });
    return response.json();
};

// Legacy portal profile (subscriptions.Profile) — kept for backward compatibility
export const getProfile = async () => {
    const response = await apiGet('/api/v1/ticketing/my-profile/');
    return response.json();
};

export const updateProfile = async (_profileId, data) => {
    const response = await apiPatch('/api/v1/ticketing/my-profile/', data);
    return response.json();
};

export const uploadAvatar = async (file) => {
    const form = new FormData();
    form.append('avatar', file);
    const response = await apiPatch('/api/v1/ticketing/my-profile/', form);
    return response.json();
};

export const getEventAttendees = async (eventId) => {
    const response = await apiGet(`/api/v1/ticketing/events/${eventId}/attendees/`);
    return response.json();
};

export const changePassword = async ({ currentPassword, newPassword }) => {
    const response = await apiPost('/api/v1/change-password', {
        current_password: currentPassword,
        new_password: newPassword,
    });
    return response;
};

// ── Ticket transfers ──────────────────────────────────────────────────────────

export const initiateTransfer = async ({ orderRef, recipientEmail }) => {
    const response = await apiPost('/api/v1/ticketing/initiate-transfer/', {
        order_ref: orderRef,
        recipient_email: recipientEmail,
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || 'Transfer failed');
    return data;
};

export const acceptTransfer = async (token) => {
    const response = await apiPost('/api/v1/ticketing/accept-transfer/', { token });
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || 'Could not accept transfer');
    return data;
};

export const getTransferStatus = async (token) => {
    const response = await apiGet(`/api/v1/ticketing/transfer-status/${token}/`);
    return response.json();
};
